<template>
   <!-- <v-card class="rigt_navbar" style="padding-left:0px"> -->
   <v-card class="overflow-hidden v-card-100 v-sheet theme--light mt-0" :class="{ 'pa-0': $store.state.isMobile }">
      <div>
         <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{alert_message}}</v-alert>
      </div>
      <v-snackbar
        v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
        <v-layout align-center pr-4>
          <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
          <v-layout column>
            <div>{{ snackbar.text }}</div>
          </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-snackbar>
      <div class="vld-parent">
         <loading :active.sync="isLoading" color="#007bff" :z-index="9999" :width="110" :height="110" :isFullPage="true"></loading>
      </div>
      <!-- View BOM popup -->
      <v-row justify="center">
         <v-dialog v-model="viewBomPopup" persistent max-width="600px" @click:outside="viewBomPopup = false">
            <v-card style="max-width: 100% !important;" class="mt-0">
               <v-card-text>
                  <div class="text-center py-4" style="font-weight: bold;">
                     <span>Production Cost: ₹{{ item_attribute_resp["Production Cost"] }}</span>
                  </div>
                  <!-- Data Table -->
                  <v-layout column>
                     <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                        <v-data-table
                           disable-pagination
                           :hide-default-footer="true"
                           :headers="bom_headers"
                           :items="bom_table_data"
                           :items-per-page="pageSize"
                           return-object
                           style="max-height: 400px; overflow-y: scroll;" 
                           class="elevation-1">
                           <template #bottom></template>
                        </v-data-table>
                     </v-col>
                  </v-layout>
               </v-card-text>
            </v-card>
         </v-dialog>
      </v-row>
      <!-- image popup -->
      <v-row justify="center">
         <v-dialog v-model="image_src_popup" max-width="840px">
            <v-card class="mt-0">
               <v-card-title class="d-flex">
                  <v-span @click = "backToTestReport">
                     <v-icon>mdi-arrow-left</v-icon>
                     View Grading Test Report
                  </v-span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="image_src_popup = false">
                     <v-icon>mdi-close</v-icon>
                  </v-btn>
               </v-card-title>
               <v-img :src="image_src" width="100%" contain></v-img>
            </v-card>
         </v-dialog>
      </v-row>
      <v-row justify="center">
         <!-- Popup Dialog -->
         <v-dialog v-model="dialog" max-width="900px">
            <v-card>
               <!-- Toolbar -->
               <v-toolbar dark color="white" flat>
                  <v-btn icon @click="dialog = false">
                     <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                  <v-toolbar-title>View Image</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialog = false">
                     <v-icon>mdi-close</v-icon>
                  </v-btn>
               </v-toolbar>
               <!-- Main Image with Navigation -->
               <v-card-text>
                  <div class="image-container">
                     <v-btn icon @click="prevSlide" class="nav-btn left-btn">
                        <v-icon>mdi-chevron-left</v-icon>
                     </v-btn>
                     <v-img :src="item_attribute_resp['Attachments'][currentIndex]" contain max-width="100%" max-height="400px" />
                     <v-btn icon @click="nextSlide" class="nav-btn right-btn">
                        <v-icon>mdi-chevron-right</v-icon>
                     </v-btn>
                  </div>
                  <!-- Thumbnail Slider -->
                  <div class="thumbnail-container">
                     <v-btn icon @click="prevThumbs" class="thumb-nav-btn">
                        <v-icon>mdi-chevron-left</v-icon>
                     </v-btn>
                     <div class="thumbnail-wrapper">
                        <v-img
                           v-for="(image, index) in item_attribute_resp['Attachments']"
                           :key="index"
                           :src="image"
                           class="thumbnail"
                           :class="{ active: index === currentIndex }"
                           @click="currentIndex = index"
                           />
                     </div>
                     <v-btn icon @click="nextThumbs" class="thumb-nav-btn">
                        <v-icon>mdi-chevron-right</v-icon>
                     </v-btn>
                  </div>
               </v-card-text>
            </v-card>
         </v-dialog>
      </v-row>
      <!-- <v-row justify="center">
         <v-dialog v-model="image_src_popup" persistent max-width="840px">
           <v-card style="max-width: 100% !important;">
             <v-card-title>
               <v-row>
                 <v-spacer />
                 <v-span @click = "image_src_popup = false">
                   <v-icon>mdi-close</v-icon>
                 </v-span>
               </v-row>
             </v-card-title>
             <v-card-text>
               <v-span>
                 <v-img :src="image_src" />
               </v-span>
             </v-card-text>
           </v-card>
         </v-dialog>
         </v-row> -->
      <!-- Test report popup -->
      <v-row justify="center">
         <v-dialog v-model="testReportPopup" persistent max-width="840px">
            <v-card style="max-width: 100% !important;">
               <v-card-title>
                  <v-row>
                     <v-spacer />
                     <v-span @click = "testReportPopup = false">
                        <v-icon>mdi-close</v-icon>
                     </v-span>
                  </v-row>
               </v-card-title>
               <v-card-text id="pdf-content">
                  <v-row class="mb-2">
                     <v-span>
                        <v-span style="color:#293079;font-size:16px;font-weight:700;" class="mt-1">GRADING TEST REPORT</v-span>
                        <div class="underline_css"></div>
                     </v-span>
                     <v-spacer />
                     <v-btn medium class="text-none" style="background-color:#003C9E; color: white;" @click="generatePDF">DOWNLOAD</v-btn>
                  </v-row>
                  <!-- item details -->
                  <v-row class="test_report_header">
                     <v-span class="ma-2">Item Details</v-span>
                  </v-row>
                  <v-row>
                     <v-col cols="4">
                        <v-span style="font-weight: bold;">Tag ID</v-span>
                     </v-col>
                     <v-col cols="8">
                        <v-span>{{grading_test_report.tag_number}}</v-span>
                     </v-col>
                  </v-row>
                  <v-row>
                     <v-col cols="4">
                        <v-span style="font-weight: bold;">EAN</v-span>
                     </v-col>
                     <v-col cols="8">
                        <v-span>{{ grading_test_report.ean }}</v-span>
                     </v-col>
                  </v-row>
                  <v-row>
                     <v-col cols="4">
                        <v-span style="font-weight: bold;">Article ID</v-span>
                     </v-col>
                     <v-col cols="8">
                        <v-span>{{ grading_test_report.article_id }}</v-span>
                     </v-col>
                  </v-row>
                  <v-row>
                     <v-col cols="4">
                        <v-span style="font-weight: bold;">Article Description</v-span>
                     </v-col>
                     <v-col cols="8">
                        <v-span>{{ grading_test_report.item_description }}</v-span>
                     </v-col>
                  </v-row>
                  <v-row>
                     <v-col cols="4">
                        <v-span style="font-weight: bold;">Brand</v-span>
                     </v-col>
                     <v-col cols="8">
                        <v-span>{{ grading_test_report.brand }}</v-span>
                     </v-col>
                  </v-row>
                  <!-- packaging -->
                  <v-row class="test_report_header">
                     <v-span class="ma-2">Packaging</v-span>
                  </v-row>
                  <v-span v-if="grading_test_report.grading_values">
                     <div v-for="(item,index) in grading_test_report.grading_values['Packaging Condition']" :key="index">
                        <v-row>
                           <v-col cols="4">
                              <v-span style="font-weight: bold;">{{ item.question }}</v-span>
                           </v-col>
                           <v-col cols="8">
                              <v-span>{{item.answer}}</v-span>
                              <div v-for="(image, index2) in item.image_urls" :key="index2">
                                 <v-span class="py-2 d-flex">
                                    <v-span class="mr-1" @click="openImagePopup(image.imageSrc)">
                                       <img :src="image.imageSrc" height="100px" width="91px"/>
                                    </v-span>
                                    <v-span v-if="image.annotatedImageSrc" class="mr-1" @click="openImagePopup(image.annotatedImageSrc)">
                                       <img :src="image.annotatedImageSrc" height="100px" width="91px"/>
                                    </v-span>
                                 </v-span>
                              </div>
                           </v-col>
                        </v-row>
                     </div>
                  </v-span>
                  <!-- Physical Condition -->
                  <v-row class="test_report_header">
                     <v-span class="ma-2">Physical Condition</v-span>
                  </v-row>
                  <v-span v-if="grading_test_report.grading_values">
                     <div v-for="(item,index) in grading_test_report.grading_values['Physical Condition']" :key="index">
                        <v-row>
                           <v-col cols="4">
                              <v-span style="font-weight: bold;">{{ item.question }}</v-span>
                           </v-col>
                           <v-col cols="8">
                              <v-span>{{item.answer}}</v-span>
                              <div v-for="(image, index2) in item.image_urls" :key="index2" class="d-flex">
                                 <v-span class="mr-1 py-2" @click="openImagePopup(image.imageSrc)">
                                    <img :src="image.imageSrc" height="100px" width="91px"/>
                                 </v-span>
                                 <v-span v-if="image.annotatedImageSrc" class="mr-1 py-2" @click="openImagePopup(image.annotatedImageSrc)">
                                    <img :src="image.annotatedImageSrc" height="100px" width="91px"/>
                                 </v-span>
                              </div>
                           </v-col>
                        </v-row>
                     </div>
                  </v-span>
                  <!-- Functional conditon -->
                  <v-row class="test_report_header">
                     <v-span class="ma-2">Functional Condition</v-span>
                  </v-row>
                  <v-span v-if="grading_test_report.grading_values">
                     <div v-for="(item,index) in grading_test_report.grading_values['Functional Condition']" :key="index">
                        <v-row>
                           <v-col cols="4">
                              <v-span style="font-weight: bold;">{{ item.question }}</v-span>
                           </v-col>
                           <v-col cols="8">
                              <v-span>{{item.answer}}</v-span>
                              <div v-for="(image, index2) in item.image_urls" :key="index2" class="d-flex">
                                 <v-span class="mr-1 py-2" @click="openImagePopup(image.imageSrc)">
                                    <v-img :src="image.imageSrc" height="100px" width="91px"/>
                                 </v-span>
                                 <v-span v-if="image.annotatedImageSrc" class="mr-1 py-2" @click="openImagePopup(image.annotatedImageSrc)">
                                    <img :src="image.annotatedImageSrc" height="100px" width="91px"/>
                                 </v-span>
                              </div>
                           </v-col>
                        </v-row>
                     </div>
                  </v-span>
               </v-card-text>
            </v-card>
         </v-dialog>
      </v-row>
      <v-row justify="center">
         <v-dialog v-model="imageDailog" persistent max-width="800px">
            <v-card style="overflow-y:auto;" class="mt-0">
               <v-card-title>
                  Image Attachment
               </v-card-title>
               <v-card-actions style="overflow-y:auto;">
                  <template v-for="(item, index) in images">
                     <v-col cols="12" sm="4" md="4" >
                        <v-row>
                           <v-checkbox
                              :id="item" :key="index" :value="item" name="item" type="checkbox" v-model="checkedImages"
                              color="indigo darken-3"
                              hide-details
                              class="pl-3"
                              ></v-checkbox>
                           <v-img :src="item" width="170" ></v-img>
                        </v-row>
                     </v-col>
                  </template>
               </v-card-actions>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn small color="blue" @click="downloadImage">Download Selected Images</v-btn>
                  <v-btn small text color="normal" @click=" closeImageDialog">Cancel</v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>
      </v-row>
      <v-row justify="center">
         <v-dialog v-model="replaceFileDialog" persistent max-width="500px">
            <v-card class="v-card-100">
               <v-card class="v-card-100 custom-shadow ma-0">
                <v-card-title class="pa-0">              
                <v-row class="ma-2">
                  <span class="font-weight-bold">Replace</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="replaceFileDialog = false">mdi-close</v-icon>
                </v-row>              
               </v-card-title>
             </v-card>
               <v-card-actions class="mt-5">
                 <v-row class="ma-2">
                    <v-col>
                    <v-file-input 
                       v-model="replace_file" 
                       variant="outlined" 
                       prepend-icon='' 
                       label="Attach JPG/PDF file" 
                       prepend-inner-icon="mdi-paperclip" 
                       accept=".pdf, .png , .jpg, .jpeg" 
                       @change="changeFile" 
                       :error="fileError" 
                       :error-messages="fileErrorMessage"/>
                    </v-col>
                  </v-row>
               </v-card-actions>
               <v-card-actions>
                  <v-spacer></v-spacer>
                 <v-btn style="font-size: 16px;" color="primary"  variant="flat" class="mb-3 text-none mr-1" :disabled="!replace_file || fileError" @click="submitUpdateConfirmation">Confirm</v-btn>
                  <v-btn style="font-size: 16px;" text color="indigo" variant="outlined" class="cancel-color btn-cancel mr-2 mb-3 text-none" @click="replaceFileDialog = false">Cancel</v-btn>
                  <v-spacer></v-spacer>
               </v-card-actions>
            </v-card>
         </v-dialog>
      </v-row>
      <!-- <v-row justify="center">
         <v-dialog v-model="imageDailog2" persistent max-width="800px">
             <v-card style="overflow-y:auto;">
             <v-card-title>
               Image Attachment
             </v-card-title>
             <v-card-actions style="overflow-y:auto;">
              
              <template>
               <v-col cols="12" sm="4" md="4" >
               <v-row>
                 <v-img :src="item_image_url" width="170" ></v-img>
                 </v-row>
               </v-col>
               </template>     
             </v-card-actions>
         
             <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn small color="blue" @click="downloadImage">Download Selected Images</v-btn>
               <v-btn small text color="normal" @click="imageDailog2 = false">Cancel</v-btn>
             </v-card-actions>
         
          </v-card>
          </v-dialog>
         </v-row> -->
      <div v-if="$store.state.isMobile === false">
         <HeaderComponent :headerTitle="header_text" />
      </div>
      <v-card-title style="display:flex;padding: 25px" class="action-style pb-4" v-if="$store.state.isMobile === false">
         <v-row>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="searched_data" :label="label_search" style="max-width: 570px;margin-left:12px"
               variant="outlined" v-on:keyup.enter="searchItem('search_by_tabnumber')"></v-text-field>
            <v-btn class="mx-4 my-2 text-none" variant="flat" :disabled="!searched_data" color="primary" @click="searchItem('search_by_tabnumber')">Submit</v-btn>
         </v-row>
      </v-card-title>
      <v-card-title style="display:flex;padding: 40px" class="action-style pb-2" v-else>
         <v-row class="ma-0 align-center">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="searched_data" :label="label_search" style="flex: 1;" class="mr-2"
               variant="outlined" hide-details v-on:keyup.enter="searchItem('search_by_tabnumber')"></v-text-field>
            <v-btn style="min-width: 48px; background-color: #E2ECFA !important; border-radius: 4px;" height="48" class="elevation-0" :disabled="!searched_data" color="secondary" @click="searchItem('search_by_tabnumber')">
               <v-icon color="#0357D0">mdi-crop-free</v-icon>
            </v-btn>
         </v-row>
      </v-card-title>
      <template v-if="searched_ird === 'tag'">
      <v-card class="v-card-100">
         <v-tabs v-model="selected_tab" show-arrows class="custom-tabs mb-5">
            <v-tab
               class="custom-tab"
               v-for="(tab, index) in tabs"
               :key="index"
               :value="index"
               ripple
               @click="loadData(tab, 'tab_clicked')"
               >
               {{ tab }}
            </v-tab>
         </v-tabs>
      </v-card>
      <v-card class="v-card-100 pb-3 mt-0 custom-card">
         <!-- <v-row class="ml-8 mr-4 mt-5"> -->
         <!-- <v-col cols="6" sm="6" md="6">
            <v-text-field class="ml-2" variant="outlined" color="primary" prepend-inner-icon="mdi-magnify" v-model="search" label="Search Item id or Serial Number" v-on:keyup.enter="searchItem()"></v-text-field>
            </v-col>
            <v-col cols="1" sm="1" md="1">
            <v-btn medium class="mr-2 mt-5 text-none" style="background-color:#0357D0 !important" color="primary" @click="searchItem()">Search</v-btn>
            </v-col> -->
         <!-- <v-col cols="2" sm="2" md="2">
            <v-chip v-if="showItemFound" class="mt-5" :color="item_status" text-color="white">{{item_text}}</v-chip>
            </v-col> -->
         <!-- <span text-color="black">Searched Data: <b>{{ searched_data }}</b></span> -->
         <!-- <v-spacer />
            <v-btn  color= 'primary' variant="outlined" class="mb-4 mr-8" @click="expand_all_function" :disabled = 'slider_disabled'>
              <span class="text-none" style="font-weight: 600;" v-if="expand_all"><i class="mdi mdi-plus mr-1"></i>Expand All</span>
              <span class="text-none" style="font-weight: 600;" v-else><i class="mdi mdi-minus mr-1"></i>Close All</span>
            </v-btn> -->
         <!-- </v-row> -->
         <v-card v-if="active_tab==='Item Attributes'" class="v-card-100 titleCarditem mt-0" :disabled='slider_disabled'>
            <v-card-title class="cardTextHeader d-flex align-center" v-if="!$store.state.isMobile">
               Item Attributes
            </v-card-title>
            <div>
               <v-divider class="ml-4 mr-4" style="border-color: #000; border-width: 1px;"></v-divider>
               <v-card-text>
                  <v-row>
                     <v-col cols="6" md="2" class="text-left">
                        <span>Tag ID *</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp['Tag ID'] }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>Sub Location *</span><br>
                        <span style="font-weight: bold;" :style="item_attribute_resp['Sub Location Status'] ? 'color: #EC0101' : ''">{{ item_attribute_resp['Sub Location'] }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>EAN*</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp.EAN }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>Article ID*</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp['Article ID'] }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>Article Description</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp['Article Description'] ? item_attribute_resp['Article Description'] : '-' }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>Serial No 1</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp['Serial Number 1'] ? item_attribute_resp['Serial Number 1'] : '-' }}</span>
                     </v-col>
                  </v-row>
                  <v-row class="mt-10">
                     <v-col cols="6" md="2" class="text-left">
                        <span>Brand</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp['Brand'] ? item_attribute_resp['Brand'] : '-' }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>Model</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp['Model'] ? item_attribute_resp['Model'] : '-' }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>MRP (₹)</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp['Mrp'] ? item_attribute_resp['Mrp'] : '-' }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>ASP(₹)</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp['Asp'] ?  item_attribute_resp['Asp'] : '-' }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>Purchase Price(₹)</span><br>
                        <span style="font-weight: bold;">{{ item_attribute_resp['Purchase Price'] ? item_attribute_resp['Purchase Price'] : '-' }}</span>
                     </v-col>
                     <v-col cols="6" md="2" class="text-left">
                        <span>BOM</span><br>
                        <v-span @click="viewBom" style="color:#0357D0;text-decoration:underline;">View</v-span>
                     </v-col>
                  </v-row>
                  <!-- image  -->
                  <!-- <v-row>
                     <v-col cols="12">
                       <v-carousel hide-delimiters>
                         <v-carousel-item
                           v-for="(image, index) in item_attribute_resp['Attachments']"
                           :key="index"
                         >
                           <v-row>
                             <v-col cols="4">
                               <v-img :src="item_attribute_resp['Attachments'][(index - 1 + item_attribute_resp['Attachments'].length) % item_attribute_resp['Attachments'].length]" />
                             </v-col>
                             <v-col cols="4">
                               <v-img :src="image" />
                             </v-col>
                             <v-col cols="4">
                               <v-img :src="item_attribute_resp['Attachments'][(index + 1) % item_attribute_resp['Attachments'].length]" />
                             </v-col>
                           </v-row>
                         </v-carousel-item>
                       </v-carousel>
                     </v-col>
                     </v-row> -->
                  <v-row v-if="item_attribute_resp['Attachments'] && item_attribute_resp['Attachments'].length > 0">
                     <v-col
                        cols="12"
                        style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100%;
                        ">
                        <div style="width: 85%; height: 100%; position: relative;">
                           <!-- Previous Button -->
                           <v-btn
                              icon
                              :disabled="currentIndex === 0"
                              @click="prevSlide"
                              style="position: absolute; top: 50%; left: -65px; transform: translateY(-50%); z-index: 10;">
                              <v-icon>mdi-menu-left</v-icon>
                           </v-btn>
                           <!-- Image Slider -->
                           <v-row>
                              <v-col
                                 v-for="(image, index) in visibleImages"
                                 :key="index"
                                 cols="3">
                                 <v-card class="image-card" outlined @click="openPopup(index)">
                                    <v-img :src="image" class="image-fit" />
                                 </v-card>
                              </v-col>
                           </v-row>
                           <!-- Next Button -->
                           <v-btn
                              icon
                              :disabled="currentIndex + imagesPerSlide >= (item_attribute_resp['Attachments'] ? item_attribute_resp['Attachments'].length : 0)"
                              @click="nextSlide"
                              style="position: absolute; top: 50%; right: -65px; transform: translateY(-50%); z-index: 10;">
                              <v-icon>mdi-menu-right</v-icon>
                           </v-btn>
                        </div>
                     </v-col>
                  </v-row>
               </v-card-text>
            </div>
         </v-card>
         <v-card v-if="active_tab==='Item Journey'"  class="v-card-100 titleCard mt-0" :disabled = 'slider_disabled'>
            <v-card-title @click="openItemJourney" class="cardTextHeader d-flex align-center" v-if="!$store.state.isMobile">
               Item Journey
            </v-card-title>
            <div>
               <v-divider class="ml-4 mr-4" style="border-color: #000; border-width: 1px;"></v-divider>
               <v-card-text class="titleCarditem">
                  <h6 class="text-center mb-5" style="font-weight: bold;">Current Stage : {{ item_journey_resp.current_stage }}</h6>
                  <div v-for="(item,index) in item_journey_resp.journey" :key="index">
                     <v-row no-gutters v-if="!$store.state.isMobile">
                        <v-col cols="4" md="2" lg="1" style="display:flex; align-items:center;">
                           <div >{{ calculate_date(item) }} <br> {{ calculate_time(item) }}</div>
                        </v-col>
                        <v-col cols="1" style="display:flex; align-items:center;">
                           <v-icon color="#1867c0 !important">mdi-radiobox-marked</v-icon>
                           <v-divider v-if="index != item_journey_resp.journey.length-1" vertical dashed class="verticalDashedDivider"/>
                        </v-col>
                        <v-col cols="7" md="9" lg="10">
                           <div class="gpOfBox pl-4">
                              <v-row class="text-left">
                                 <v-col cols="6" md="4">
                                    <span style="font-weight: bold;">Disposition</span><br>
                                    <span>{{ item.disposition ? item.disposition : '-' }}</span><br>
                                 </v-col>
                                 <v-col cols="6" md="4">
                                    <span style="font-weight: bold;">Action</span><br>
                                    <span>{{ item.action ? item.action : '-' }}</span>
                                 </v-col>
                                 <v-col cols="12" md="4">
                                    <span style="font-weight: bold;">User</span><br>
                                    <span>{{ item.user ? item.user : '-' }}</span>
                                 </v-col>
                              </v-row>
                              <v-row class="text-left">
                                 <v-col cols="6" md="4">
                                    <span style="font-weight: bold;">Action Outcome</span><br>
                                       <span>{{ item.action_outcome ? item.action_outcome : '-' }}</span>
                                 </v-col>
                                 <v-col cols="6" md="4">
                                    <span style="font-weight: bold;">Next Stage</span><br>
                                    <span>{{ item.next_stage ?  item.next_stage : '-' }}</span>
                                 </v-col>
                              </v-row>
                           </div>
                        </v-col>
                     </v-row>
                     <div v-else class="mb-4">
                        <div class="text-center font-weight-bold mb-4">
                           <div style="font-size:14px; font-weight: bold;">{{ calculate_date(item) }}</div>
                           <div style="font-size:14px; font-weight: bold;">{{ calculate_time(item) }}</div>
                        </div>
                        <div class="pa-4 rounded-lg text-left mx-2 mb-6" style="background-color: #f8f9f9; border-radius: 12px !important;">
                           <div class="mb-3">
                              <div style="font-size: 14px; color: #666;">Disposition</div>
                              <div style="font-weight: bold; font-size: 14px; color: #000;">{{ item.disposition ? item.disposition : '-' }}</div>
                           </div>
                           <div class="mb-3">
                              <div style="font-size: 14px; color: #666;">Action</div>
                              <div style="font-weight: bold; font-size: 14px; color: #000;">{{ item.action ? item.action : '-' }}</div>
                           </div>
                           <div class="mb-3">
                              <div style="font-size: 14px; color: #666;">User</div>
                              <div style="font-weight: bold; font-size: 14px; color: #000;">{{ item.user ? item.user : '-' }}</div>
                           </div>
                           <div class="mb-3">
                              <div style="font-size: 14px; color: #666;">Action Outcome</div>
                              <div style="font-weight: bold; font-size: 14px; color: #000;">{{ item.action_outcome ? item.action_outcome : '-' }}</div>
                           </div>
                           <div>
                              <div style="font-size: 14px; color: #666;">Next Stage</div>
                              <div style="font-weight: bold; font-size: 14px; color: #000;">{{ item.next_stage ?  item.next_stage : '-' }}</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </v-card-text>
            </div>
         </v-card>
         <v-card class="v-card-100 titleCard mt-0" v-if="active_tab==='Financial Journey'"  :disabled = 'slider_disabled'>
            <v-card-title @click="openFinancialJourney" class="cardTextHeader d-flex align-center" v-if="!$store.state.isMobile">
               Financial Journey
            </v-card-title>
            <div class="titleCarditem">
               <v-divider class="ml-4 mr-4" style="border-color: #000; border-width: 1px;"></v-divider>
               <v-card-text :class="$store.state.isMobile ? 'pa-4' : 'ml-4 mr-4'">
                  <v-row class="mr-5 ml-0" v-if="!$store.state.isMobile">
                     <span class="bold-size">Total Credit</span>
                     <span class="ml-2 bold-size">₹{{ formatCurrency(financial_journey_resp.total_credit) }}</span>
                     <v-spacer></v-spacer>
                     <span class="bold-size">Total Debit</span>
                     <span class="ml-2 bold-size">₹{{ formatCurrency(financial_journey_resp.total_debit) }}</span>
                     <v-spacer></v-spacer>
                     <span class="bold-size">Net Impact</span>
                     <span
                           class="ml-2 mr-2 bold-size"
                           :class="financial_journey_resp.net_impact > 0 ? 'text-success' : 'error-color'"
                           >
                           ₹{{ formatCurrency(financial_journey_resp.net_impact) }}
                           </span>
                  </v-row>
                  <v-row class="ma-0 text-left mb-6" v-else>
                     <v-col cols="4" class="pa-1">
                        <div style="font-size:12px; color:#000; font-weight:600;">Total Credit</div>
                        <div style="font-size:14px; font-weight:bold; margin-top: 4px;">₹{{ formatCurrency(financial_journey_resp.total_credit) }}</div>
                     </v-col>
                     <v-col cols="4" class="pa-1">
                        <div style="font-size:12px; color:#000; font-weight:600;">Total Debit</div>
                        <div style="font-size:14px; font-weight:bold; margin-top: 4px;">₹{{ formatCurrency(financial_journey_resp.total_debit) }}</div>
                     </v-col>
                     <v-col cols="4" class="pa-1">
                        <div style="font-size:12px; color:#000; font-weight:600;">Net Impact</div>
                        <div style="font-size:14px; font-weight:bold; margin-top: 4px;" :class="financial_journey_resp.net_impact > 0 ? 'text-success' : 'error-color'">₹{{ formatCurrency(financial_journey_resp.net_impact) }}</div>
                     </v-col>
                  </v-row>
                  <div v-if="!$store.state.isMobile">
                     <div style="margin-top: 30px" class="mb-3 text-left bold-size">Forward Supply Chain</div>
                     <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                        <v-list-item-content>
                           <v-data-table
                              :dense="true"
                              :headers="forwardHeader"
                              class="elevation-1"
                              :items="forwardTableData"
                              style="max-height: 200px; overflow-y: scroll;" 
                              disable-pagination
                              :hide-default-footer="true"
                              >
                              <template v-slot:item.credit="{ item }">
                                 <span>{{ formatCurrency(item.credit) }}</span>
                              </template>
                              <template v-slot:item.debit="{ item }">
                                 <span>{{ formatCurrency(item.debit) }}</span>
                              </template>
                              <template v-slot:item.balance="{ item }">
                                 <span>{{ formatCurrency(item.balance) }}</span>
                              </template>
                              <template #bottom></template>
                           </v-data-table>
                        </v-list-item-content>
                     </v-col>
                  </div>
                  <div v-else class="mb-4">
                     <v-expansion-panels flat style="border: 1px solid #ccc; border-radius: 8px;">
                        <v-expansion-panel class="rounded-lg">
                           <v-expansion-panel-title class="font-weight-bold" style="font-size:14px; min-height:48px; padding: 12px 16px;">
                                <template #actions></template>
                              <div class="d-flex align-center" style="width: 100%;">
                                 <span>Forward Supply Chain</span>
                                 <v-spacer></v-spacer>
                                 <div class="expansion-icon" style="background: #F4F6F9; border-radius: 50%; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;">
                                    <v-icon size="small">mdi-chevron-down</v-icon>
                                 </div>
                              </div>
                           </v-expansion-panel-title>
                           <v-divider v-if="forwardTableData && forwardTableData.length" class="mt-2" style="border-color: black; border-width: 1px;"></v-divider>

                           <!-- Card for First Item (Visible when collapsed) -->
                           <div class="pr-4 pl-7 mb-3 bg-white text-left" v-if="forwardTableData && forwardTableData.length">
                              <!-- Row 1 -->
                              <v-row no-gutters>
                                 <v-col cols="6">
                                    <div class="label">Date</div>
                                    <div class="value">{{ forwardTableData[0].date || forwardTableData[0].created_at || '01/12/2023' }}</div>
                                 </v-col>
                                 <v-col cols="6">
                                    <div class="label">Transaction Description</div>
                                    <div class="value text-truncate">{{ forwardTableData[0].transaction || forwardTableData[0].transaction_description || 'Cost Of goods sold' }}</div>
                                 </v-col>
                              </v-row>

                              <!-- Row 2 -->
                              <v-row no-gutters class="mt-1">
                                 <v-col cols="6">
                                    <div class="label">Credit</div>
                                    <div class="value">{{ forwardTableData[0].credit ? '₹' + formatCurrency(forwardTableData[0].credit) : '-' }}</div>
                                 </v-col>
                                 <v-col cols="6">
                                    <div class="label">Debit</div>
                                    <div class="value">{{ forwardTableData[0].debit ? '₹' + formatCurrency(forwardTableData[0].debit) : '-' }}</div>
                                 </v-col>
                              </v-row>

                              <!-- Row 3 -->
                              <v-row no-gutters class="mt-1">
                                 <v-col cols="12">
                                    <div class="label">Balance</div>
                                    <div class="value">{{ forwardTableData[0].balance ? '₹' + formatCurrency(forwardTableData[0].balance) : '-' }}</div>
                                 </v-col>
                              </v-row>
                           </div>
                           <div v-else class="pa-2 text-center" style="font-style: italic; border-top: 1px solid #ccc;">
                              No data found
                           </div>

                           <v-expansion-panel-text>
                              <!-- <div v-if="forwardTableData && forwardTableData.length > 0"> -->
                              <div v-for="(item, i) in forwardTableData.slice(1)" :key="i" class="pa-2" style="border-top: 1px solid #eee;">
                                 <v-row no-gutters class="text-left mb-2">
                                    <v-col cols="6"><div class="label">Date</div><div class="value">{{ item.date || item.created_at || '01/12/2023' }}</div></v-col>
                                    <v-col cols="6"><div class="label">Transaction Description</div><div class="value">{{ item.transaction || item.transaction_description || 'Cost Of goods sold' }}</div></v-col>
                                 </v-row>
                                 <v-row no-gutters class="text-left mb-2">
                                    <v-col cols="6"><div class="label">Credit</div><div class="value">{{ item.credit ? '₹' + formatCurrency(item.credit) : '-' }}</div></v-col>
                                    <v-col cols="6"><div class="label">Debit</div><div class="value">{{ item.debit ? '₹' + formatCurrency(item.debit) : '-' }}</div></v-col>
                                 </v-row>
                                 <v-row no-gutters class="text-left">
                                    <v-col cols="12"><div class="lable">Balance</div><div class="value">{{ item.balance ? '₹' + formatCurrency(item.balance) : '-' }}</div></v-col>
                                 </v-row>
                              </div>
                              <!-- </div> -->
                           </v-expansion-panel-text>
                        </v-expansion-panel>
                     </v-expansion-panels>
                  </div>
                  <div v-if="!$store.state.isMobile">
                     <div style="font-weight: bold;;margin-top: 20px" class="mb-3 text-left bold-size">Reverse Supply Chain</div>
                     <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                        <v-list-item-content>
                           <v-data-table
                              :dense="true"
                              :headers="reverseHeader"
                              class="elevation-1"
                              :items="reverseTableData"
                              style="max-height: 200px; overflow-y: scroll;" 
                              disable-pagination
                              fixed-header
                              height="100%"
                              :items-per-page="reverseTableData.length"
                              :hide-default-footer="true"
                              >
                              <template v-slot:item.credit="{ item }">
                                 <span>{{ formatCurrency(item.credit) }}</span>
                              </template>
                              <template v-slot:item.debit="{ item }">
                                 <span>{{ formatCurrency(item.debit) }}</span>
                              </template>
                              <template v-slot:item.balance="{ item }">
                                 <span>{{ formatCurrency(item.balance) }}</span>
                              </template>
                              <template #bottom></template>
                           </v-data-table>
                        </v-list-item-content>
                     </v-col>
                  </div>
                  <div v-else class="mb-4">
                     <v-expansion-panels flat style="border: 1px solid #ccc; border-radius: 8px;">
                        <v-expansion-panel class="rounded-lg">
                           <v-expansion-panel-title class="font-weight-bold mb-0 pb-0" style="font-size:14px; min-height:48px; padding: 12px 16px;">
                                <template #actions></template>
                              <div class="d-flex align-center" style="width: 100%;">
                                 <span>Reverse Supply Chain</span>
                                 <v-spacer></v-spacer>
                                 <div class="expansion-icon" style="background: #F4F6F9; border-radius: 50%; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;">
                                    <v-icon size="small">mdi-chevron-down</v-icon>
                                 </div>
                              </div>
                           </v-expansion-panel-title>
                           <v-divider v-if="reverseTableData && reverseTableData.length" class="mt-2" style="border-color: black;  border-width: 1px;"></v-divider>

                           <!-- Card for First Item (Visible when collapsed) -->
                           <div class="pr-4 pl-7 mb-3 bg-white text-left" v-if="reverseTableData && reverseTableData.length">
                              <!-- Row 1 -->
                              <v-row no-gutters>
                                 <v-col cols="6">
                                    <div class="label">Date</div>
                                    <div class="value">{{ reverseTableData[0].date || reverseTableData[0].created_at || '05/12/2023' }}</div>
                                 </v-col>
                                 <v-col cols="6">
                                    <div class="label">Transaction Description</div>
                                    <div class="value text-truncate">{{ reverseTableData[0].transaction || reverseTableData[0].transaction_description || 'Service Cost(Apportioned)' }}</div>
                                 </v-col>
                              </v-row>

                              <!-- Row 2 -->
                              <v-row no-gutters class="mt-1">
                                 <v-col cols="6">
                                    <div class="label">Credit</div>
                                    <div class="value">{{ reverseTableData[0].credit ? '₹' + formatCurrency(reverseTableData[0].credit) : '-' }}</div>
                                 </v-col>
                                 <v-col cols="6">
                                    <div class="label">Debit</div>
                                    <div class="value">{{ reverseTableData[0].debit ? '₹' + formatCurrency(reverseTableData[0].debit) : '-' }}</div>
                                 </v-col>
                              </v-row>

                              <!-- Row 3 -->
                              <v-row no-gutters class="mt-1">
                                 <v-col cols="12">
                                    <div class="label">Balance</div>
                                    <div class="value">{{ reverseTableData[0].balance ? '₹' + formatCurrency(reverseTableData[0].balance) : '-' }}</div>
                                 </v-col>
                              </v-row>
                           </div>
                           <div v-else class="pa-2 text-center" style="font-style: italic; border-top: 1px solid #ccc;">
                              No data found
                           </div>

                           <v-expansion-panel-text>
                              <div v-for="(item, i) in reverseTableData.slice(1)" :key="i" class="pa-2" style="border-top: 1px solid #eee;">
                                 <v-row no-gutters class="text-left mb-2">
                                    <v-col cols="6"><div class="label">Date</div><div class="value">{{ item.date || item.created_at || '-' }}</div></v-col>
                                    <v-col cols="6"><div class="label">Transaction Description</div><div class="text-truncate value">{{ item.transaction || item.transaction_description || 'Service Cost(Apportioned)' }}</div></v-col>
                                 </v-row>
                                 <v-row no-gutters class="text-left mb-2">
                                    <v-col cols="6"><div class="label">Credit</div><div class="value">{{ item.credit ? '₹' + formatCurrency(item.credit) : '-' }}</div></v-col>
                                    <v-col cols="6"><div class="label">Debit</div><div class="value">{{ item.debit ? '₹' + formatCurrency(item.debit) : '-' }}</div></v-col>
                                 </v-row>
                                 <v-row no-gutters class="text-left">
                                    <v-col cols="12"><div class="label">Balance</div><div class="value">{{ item.balance ? '₹' + formatCurrency(item.balance) : '-' }}</div></v-col>
                                 </v-row>
                              </div>
                           </v-expansion-panel-text>
                        </v-expansion-panel>
                     </v-expansion-panels>
                  </div>
               </v-card-text>
            </div>
         </v-card>
         <v-card class="v-card-100 titleCard mt-0" v-if="active_tab==='Grading Journey'" :disabled='slider_disabled' >
            <v-card-title @click="openGradingJourney" class="cardTextHeader d-flex align-center" v-if="!$store.state.isMobile">
               Grading Journey
            </v-card-title>
            <div class="titleCarditem">
               <v-divider class="ml-4 mr-4" style="border-color: #000; border-width: 1px;"></v-divider>
               <v-card-text v-if="grading_journey_resp.length == 0" class="text-center">
                  <span>No Data Available</span>
               </v-card-text>
               <v-card-text v-else>
                  <div v-for="(item,index) in grading_journey_resp" :key = "index">
                     <v-row v-if="!$store.state.isMobile">
                        <v-col cols="4" md="2" lg="1" class="text-left" style="display:flex; align-items:center;">
                           <div >{{ grading_date(item) }} <br> {{ grading_time(item) }}</div>
                        </v-col>
                        <v-col cols="1" style="display:flex; align-items:center;">
                           <v-icon color="#1867c0 !important">mdi-radiobox-marked</v-icon>
                        </v-col>
                        <v-col cols="7" md="9" lg="10">
                           <div class="gpOfBox pl-4 pb-4">
                              <v-row class="ma-5">
                                 <v-col cols="6" md="3" style="line-height: 2;">
                                    <span>Type of Grading</span><br>
                                    <span style="font-weight: bold;">{{ item.request_type ?  item.request_type : '-'}}</span>
                                 </v-col>
                                 <v-col cols="6" md="3" style="line-height: 2;">
                                    <span>Grade/User</span><br>
                                    <span style="font-weight: bold;">{{ item.grader_name ? item.grader_name : '-' }}</span>
                                 </v-col>
                                 <v-col cols="6" md="3" style="line-height: 2;" >
                                    <span>Grade</span><br>
                                    <span style="font-weight: bold;">{{ item.grade ? item.grade : '-' }}</span>
                                 </v-col>
                                 <v-col cols="6" md="2" style="line-height: 2;" class="text-left">
                                    <div style="color: #1D88FB; text-decoration: underline;" @click="viewTestReport(index)">View Test Report 
                                    </div>
                                 </v-col>
                              </v-row>                              
                           </div>
                        </v-col>
                     </v-row>
                     <div v-else class="mb-4">
                        <div class="text-center font-weight-bold mb-4">
                           <div style="font-size:14px; font-weight: bold;">{{ grading_date(item) }}</div>
                           <div style="font-size:14px; font-weight: bold;">{{ grading_time(item) }}</div>
                        </div>
                        <div class="pa-4 rounded-lg text-left mx-2 mb-6" style="background-color: #f8f9f9; border-radius: 12px !important;">
                           <div class="mb-3">
                              <div style="font-size: 14px; color: #666;">Type Of Grading</div>
                              <div style="font-weight: bold; font-size: 14px; color: #000;">{{ item.request_type ?  item.request_type : '-'}}</div>
                           </div>
                           <div class="mb-3">
                              <div style="font-size: 14px; color: #666;">Grader/User</div>
                              <div style="font-weight: bold; font-size: 14px; color: #000;">{{ item.grader_name ? item.grader_name : '-' }}</div>
                           </div>
                           <div class="mb-3">
                              <div style="font-size: 14px; color: #666;">Grade</div>
                              <div style="font-weight: bold; font-size: 14px; color: #000;">{{ item.grade ? item.grade : '-' }}</div>
                           </div>
                           <div class="mt-4">
                              <span style="color: #1D88FB; text-decoration: underline; font-weight:500;" @click="viewTestReport(index)">View Test Report</span>
                           </div>
                        </div>
                     </div>
                  </div>
               </v-card-text>
            </div>
         </v-card>
         <v-card class="v-card-100 titleCard mt-0" v-if="active_tab==='Warranty History'" :disabled = 'slider_disabled'>
            <v-card-title @click="openWarrantyJourney" class="cardTextHeader d-flex align-center" v-if="!$store.state.isMobile">
               Warranty History
            </v-card-title>
            <div class="titleCarditem">
               <v-divider class="ml-4 mr-4" style="border-color: #000; border-width: 1px;"></v-divider>
               <v-card-text v-if="warranty_history_resp.length == 0" class="text-center">
                  <span>No Data Available</span>
               </v-card-text>
               <v-card-text v-else>
                  <div v-if="!$store.state.isMobile">
                     <v-row class="mr-5 ml-4">
                        <span style="font-weight: bold;">
                           Validity Date: 
                           <tab></tab>
                           3/12/2023
                        </span>
                        <v-spacer></v-spacer>
                        <span style="font-weight: bold;">
                           Status : 
                           <tab></tab>
                           Closed
                        </span>
                        <v-spacer></v-spacer>
                        <span style="font-weight: bold;">
                           Servicing Cost : 
                           <tab></tab>
                           15,900
                        </span>
                     </v-row>
                     <v-flex style="overflow: auto">
                        <v-list-item-content>
                           <v-data-table
                              :dense="true"
                              :headers="warantyHeader"
                              class="elevation-1"
                              :items="warantyTableData"
                              style="max-height: 300px; overflow-y: scroll;" 
                              disable-pagination
                              :hide-default-footer="true"
                              >
                              <template #bottom></template>
                           </v-data-table>
                        </v-list-item-content>
                     </v-flex>
                  </div>
                  <div v-else class="mx-2 mb-4">
                     <v-row class="ma-0 text-left mb-6">
                        <v-col cols="4" class="pa-1">
                           <div style="font-size:12px; color:#000; font-weight:600;">Validity Date</div>
                           <div style="font-size:14px; font-weight:bold; margin-top: 4px;">21/02/2024</div>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                           <div style="font-size:12px; color:#000; font-weight:600;">Status</div>
                           <div style="font-size:14px; font-weight:bold; margin-top: 4px;" class="text-success">Active</div>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                           <div style="font-size:12px; color:#000; font-weight:600;">Servicing Cost</div>
                           <div style="font-size:14px; font-weight:bold; margin-top: 4px;">₹4,900</div>
                        </v-col>
                     </v-row>
                     <div v-for="(item, i) in warantyTableData" :key="i" class="border rounded-lg pa-4 mb-4 text-left" style="border: 1px solid #ccc;">
                        <v-row no-gutters class="mb-3">
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Date</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.date || item.created_at || '-' }}</div></v-col>
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Warranty Claim Instance</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.warrantyDate || item.warranty_claim_instance || 'WC-003' }}</div></v-col>
                        </v-row>
                        <v-row no-gutters class="mb-3">
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Sales Channel</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.salesChannel || item.sales_channel || 'online' }}</div></v-col>
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Claim Channel</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.claimChannel || item.claim_channel || 'Customer' }}</div></v-col>
                        </v-row>
                        <v-row no-gutters class="mb-3">
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Defect Type</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.defectType || item.defect_type || 'Power Supply Defect' }}</div></v-col>
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Resolution Decision</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.resolutionDecision || item.resolution_decision || 'Approved' }}</div></v-col>
                        </v-row>
                        <v-row no-gutters class="mb-3">
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Closure Date</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.closureDate || item.closure_date || '-' }}</div></v-col>
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Status</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.status || 'Open' }}</div></v-col>
                        </v-row>
                        <v-row no-gutters>
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Warranty servicing Cost</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.warrantyCost || item.warranty_servicing_cost || '₹900' }}</div></v-col>
                           <v-col cols="6"><div style="font-size:13px;color:#666;">Status Updates</div><div style="font-size:13px;font-weight:bold;color:#000;">{{ item.statusUpdates || item.status_updates || 'Power supply component' }}</div></v-col>
                        </v-row>
                     </div>
                  </div>
               </v-card-text>
            </div>
         </v-card>
         <v-card class="v-card-100 titleCard mt-0" v-if="active_tab==='Document Repository'" :disabled = 'slider_disabled'>
            <v-card-title @click="openDocumentRepo" class="cardTextHeader d-flex align-center" v-if="!$store.state.isMobile">
               Document Repository
               <v-spacer></v-spacer>
            </v-card-title>
            <div class="titleCarditem">
               <v-divider class="ml-4 mr-4" style="border-color: #000; border-width: 1px;"></v-divider>
               <v-card-text class="pt-0">
                  <v-row>
                     <v-text-field class="mt-4" prepend-inner-icon="mdi-magnify" v-model="searched_document" label="Search" style="max-width: 200px;margin-left:12px" variant="outlined" v-on:keyup.enter="getDocumentRepository"></v-text-field>
                  </v-row>
                  <div v-if="document_repository_resp.documents && document_repository_resp.documents.length == 0" class="text-center">
                     No Document Available
                  </div>
                  <div v-if="!$store.state.isMobile">
                     <div v-for="(item, index) in document_repository_resp.documents" :key="index">
                        <v-row style="max-height:48px; margin:4px;">
                           <v-icon color="primary" class="iconStyle">mdi-paperclip</v-icon>
                           <span class="pl-1 text-left">
                           {{ item.document_name}}<br>
                           <span style="font-style:italic;">{{ item.file_name }} &nbsp;&nbsp;&nbsp;&nbsp;  {{ item.created_at}}</span>
                           </span>
                           <v-spacer></v-spacer>
                           <a :href="item.document_path" target="_blank" style="color:#1D88FB; text-decoration:underline; padding: 8px; font-size: 14px"><i style="position: relative; top: 6px;" class="mdi mdi-eye mr-2 mdi-24px"></i>Preview</a>
                           <v-divider vertical inset />
                           <a @click="downloadFile(item.document_path)" style="color:#1D88FB; text-decoration:underline; padding: 8px; font-size: 14px"><i style="position: relative; top: 6px;" class="mdi mdi-download mdi-24px mr-2"></i>Download</a>
                           <v-divider vertical inset />
                           <a v-if="role == 'admin'" @click="openDialogFile(item)" style="color:#1D88FB; text-decoration:underline; padding: 8px; font-size: 14px"><i style="position: relative; top: 6px;" class="mdi mdi-folder-plus mdi-24px mr-2"></i>Replace</a>
                        </v-row>
                     </div>
                  </div>
                  <div v-else class="mx-2 mb-4">
                     <div v-for="(item, i) in document_repository_resp.documents" :key="i" class="mb-5 text-left">
                        <div class="d-flex align-center -mb-2 mt-2">
                           <div class="pa-2 rounded-lg elevation-0 mr-3 d-flex align-center justify-center" style="background-color:#F4F6F9; height:50px; width:50px;">
                              <v-icon color="#5A6C8B" style="font-size:24px;">mdi-file-outline</v-icon>
                           </div>
                           <div>
                              <div style="font-size:14px; font-weight:bold; color:#000;">{{ item.document_name }}</div>
                              <div style="font-size:13px; color:#666; margin-top:2px;">
                                 <span>{{ item.file_name }}</span>
                                 <span class="ml-2 font-italic" style="color:#888;">{{ item.created_at || '24th Mar, 2023' }}</span>
                              </div>
                           </div>
                        </div>
                        <div class="d-flex align-center mt-3 ml-2" :style="$store.state.isMobile ? 'padding-left: 0px;' : 'padding-left: 60px;'">
                           <a :href="item.document_path" target="_blank" style="color:#1D88FB; text-decoration:none; font-size: 14px; font-weight:500;" class="d-flex align-center mr-4">
                              <v-icon color="#1D88FB" class="mr-1" style="font-size:20px;">mdi-eye-outline</v-icon> Preview
                           </a>
                           <div style="height:15px; width:1.5px; background-color:#E2E8F0;" class="mr-4"></div>
                           <a @click="downloadFile(item.document_path)" style="color:#1D88FB; text-decoration:none; font-size: 14px; font-weight:500;" class="d-flex align-center mr-4">
                              <v-icon color="#1D88FB" class="mr-1" style="font-size:20px;">mdi-download-outline</v-icon> Download
                           </a>
                           <div v-if="role == 'admin'" style="height:15px; width:1.5px; background-color:#E2E8F0;" class="mr-4"></div>
                           <a v-if="role == 'admin'" @click="openDialogFile(item)" style="color:#1D88FB; text-decoration:none; font-size: 14px; font-weight:500;" class="d-flex align-center">
                              <v-icon color="#1D88FB" class="mr-1" style="font-size:20px;">mdi-folder-upload-outline</v-icon> Replace
                           </a>
                        </div>
                     </div>
                  </div>
               </v-card-text>
            </div>
         </v-card>
      </v-card>
      </template>
      <template v-else>
        <div class="ma-0 overflow-y-auto dynamic-height-dis-card overflow-x-hidden container-fluid">
        <div style="margin-top: 30px;">
            <v-row class="p-3 customer-details text-left" >
              <label>IRD Journey</label>
            </v-row>
        </div>
        <v-row class="p-3 text-left">
        <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>IRD Journey Status</p>
            <p class="detail-heading">{{ getLastStatus(ird_details.ird_journey?.journey_status) }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>First Receipt Date</p>
              <p class="detail-heading">{{ird_details.ird_journey && ird_details.ird_journey.reciept_date ? ird_details.ird_journey.reciept_date : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>PRD Creation Date</p>
              <p class="detail-heading">{{ird_details.ird_journey && ird_details.ird_journey.prd_creation_date ? ird_details.ird_journey.prd_creation_date : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>PRD Completion Date</p>
              <p class="detail-heading"> {{ird_details.ird_journey && ird_details.ird_journey.prd_completion_date ? ird_details.ird_journey.prd_completion_date : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>PRD Deletion date</p>
              <p class="detail-heading">{{ird_details.ird_journey && ird_details.ird_journey.prd_deletion_date ? ird_details.ird_journey.prd_deletion_date : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>GRN Date</p>
              <p class="detail-heading">{{ird_details.ird_journey && ird_details.ird_journey.grn_date ? ird_details.ird_journey.grn_date : '-' }}</p>
            </v-col>
        </v-row>

        <div style="margin-top: 30px;">
            <v-row class="p-3 customer-details text-left" >
              <label>IRD Summary <span style="font-size: 14px;">(Disposition or Status & Count)</span></label>
            </v-row>
        </div>
        <v-row class="p-3 text-left">
          <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Pending GRN</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.pending_grn ? ird_details.ird_summary.pending_grn : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Short</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.short ? ird_details.ird_summary.short : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Restock</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.restock ? ird_details.ird_summary.restock : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Brand Call Log</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.brand_call_log ? ird_details.ird_summary.brand_call_log : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Insurance</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.insurance ? ird_details.ird_summary.insurance : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>RTV</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.rtv ? ird_details.ird_summary.rtv : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Replacement</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.replacement ? ird_details.ird_summary.replacement : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>markdown</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.markdown ? ird_details.ird_summary.markdown : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Repair</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.repair ? ird_details.ird_summary.repair : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Liquidation</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.liquidation ? ird_details.ird_summary.liquidation : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Grading</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.grading ? ird_details.ird_summary.grading : '-' }}</p>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="text-left">
              <p>Dispatched</p>
              <p class="detail-heading">{{ird_details.ird_summary && ird_details.ird_summary.dispatched ? ird_details.ird_summary.dispatched : '-' }}</p>
            </v-col>
        </v-row>
        <div style="margin-top: 30px;" v-if="!$store.state.isMobile">
            <v-row class="p-3 customer-details text-left" >
              <label>IRD Details</label>
            </v-row>
        </div>
        <v-row class="text-left mt-5 container-fluid no-padding-row">
        <!-- Data Table -->
        <div v-if="!$store.state.isMobile">
          <v-layout column>
            <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
              <v-data-table
                disable-pagination
                :hide-default-footer="true"
                :headers="ird_det_headers"
                :items="ird_det_items"
                :items-per-page="pageSize"
                return-object
                fixed-header
                height="100%"
                style="max-height: 400px; overflow-y: scroll;" 
                class="elevation-1">
                <template v-slot:item.tag_number="{ item }">
                  <span>{{ item.tag_number ? item.tag_number : '-' }}</span>
                </template>
                <template #bottom></template>
              </v-data-table>
          <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </v-col>
          </v-layout>
        </div>
        <div v-else class="mb-4" style="margin-right: -10px;">
          <v-expansion-panels flat style="box-shadow: none !important;">
            <v-expansion-panel class="rounded-lg" style="background: transparent !important;">

              <!-- 🔹 HEADER & FIRST ITEM -->
              <v-expansion-panel-title class="pa-0 d-block" style="background: transparent !important;">
                <template #actions></template>

                <!-- Full-Width Styled Header Bar -->
                <div>
                  <v-row class="p-3 customer-details text-left ma-0" style="width: 100%; border-radius: 4px;">
                    <v-col class="pa-0 d-flex justify-space-between align-center">
                      <label style="color: #002F9E; font-weight: 600; font-size: 14px;">IRD Details</label>
                      <div class="expansion-icon" style="background: #F4F6F9; border-radius: 50%; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;">
                        <v-icon size="small">mdi-chevron-down</v-icon>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Card for First Item (Visible when collapsed) -->
                <div class="mt-4 pa-4 bg-white" style="border: 1px solid #e1e4e8; border-radius: 12px; margin-left: 8px; margin-right: 8px;">
                  <div v-if="ird_det_items && ird_det_items.length">
                    <!-- Row 1 -->
                    <v-row no-gutters>
                      <v-col cols="6">
                        <div class="label">Tag ID</div>
                        <div class="value">{{ ird_det_items[0].tag_number || '-' }}</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="label">Article ID</div>
                        <div class="value">{{ ird_det_items[0].article_id || '-' }}</div>
                      </v-col>
                    </v-row>

                    <!-- Row 2 -->
                    <v-row no-gutters class="mt-1">
                      <v-col cols="6">
                        <div class="label">Map</div>
                        <div class="value">{{ ird_det_items[0].map || '-' }}</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="label">Article Description</div>
                        <div class="value text-truncate">
                          {{ ird_det_items[0].article_description || '-' }}
                        </div>
                      </v-col>
                    </v-row>

                    <!-- Row 3 -->
                    <v-row no-gutters class="mt-1">
                      <v-col cols="12">
                        <div class="label">Disposition Or Status</div>
                        <div class="value">{{ ird_det_items[0].disposition || '-' }}</div>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else class="pa-2 text-center" style="font-style: italic;">
                    No data found
                  </div>
                </div>

              

              <!-- 🔹 EXPANDED CONTENT -->
              <v-expansion-panel-text class="pa-0 no-indent">
                <div class="bg-white" style="border: 1px solid #e1e4e8; border-top: none; border-radius: 0 0 12px 12px; margin-top: -12px; margin-left: 8px; margin-right: 8px;">
                  <div v-if="ird_det_items && ird_det_items.length > 1">
                    <div
                      v-for="(item, i) in ird_det_items.slice(1)"
                      :key="i"
                      class="pa-4"
                      style="border-top:1px solid #eee;"
                    >
                      <v-row no-gutters>
                        <v-col cols="6">
                          <div class="label">Tag ID</div>
                          <div class="value">{{ item.tag_number || '-' }}</div>
                        </v-col>
                        <v-col cols="6">
                          <div class="label">Article ID</div>
                          <div class="value">{{ item.article_id || '-' }}</div>
                        </v-col>
                      </v-row>

                      <v-row no-gutters class="mt-1">
                        <v-col cols="6">
                          <div class="label">Map</div>
                          <div class="value">{{ item.map || '-' }}</div>
                        </v-col>
                        <v-col cols="6">
                          <div class="label">Article Description</div>
                          <div class="value text-truncate">{{ item.article_description || '-' }}</div>
                        </v-col>
                      </v-row>

                      <v-row no-gutters class="mt-1">
                        <v-col cols="12">
                          <div class="label">Disposition Or Status</div>
                          <div class="value">{{ item.disposition || '-' }}</div>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                  <div v-intersect="onIrdIntersect" v-show="page < totalPages" class="text-center pa-4">
                    <v-progress-circular v-if="loadingIrdItems" indeterminate color="primary"></v-progress-circular>
                  </div>
                </div>
              </v-expansion-panel-text>
              </v-expansion-panel-title>

            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        </v-row>
        </div>
      </template>
      <v-layout column>
         <v-flex md6 style="overflow: auto"> 
         </v-flex>
      </v-layout>
   </v-card>
</template>

<script>
  import $ from 'jquery'
  import Loading from 'vue-loading-overlay';
  // import 'vue-loading-overlay/dist/vue-loading.css';
  import Editor from "@tinymce/tinymce-vue";
  import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  import html2pdf from 'html2pdf.js';
 import { securedAxiosInstance, plainAxiosInstance,IS_QA_SERVER,API_URL } from '@/backend/axios'
  export default {
    data() {
      return {  
        isLoading: false,
        alert: false,
        search: '',
        selected_tab: 0,
        active_tab: "Item Attributes",
        tabs: [
          "Item Attributes",
          "Item Journey",
          "Financial Journey",
          "Grading Journey",
          "Warranty History",
          "Document Repository"
        ],
        customImages: [
        "https://i.rtings.com/assets/pages/IxCXzynA/best-apple-laptops-20241009-medium.jpg",
        "https://cdn.mos.cms.futurecdn.net/aU4pys8HozWWA8BGnegVU6-1200-80.jpg",
        "https://m.media-amazon.com/images/G/31/img24/asus/f16/mac-1400_2._SX1242_QL85_FMpng_.png",
        "https://i.rtings.com/assets/pages/IxCXzynA/best-apple-laptops-20241009-medium.jpg",
        "https://cdn.mos.cms.futurecdn.net/aU4pys8HozWWA8BGnegVU6-1200-80.jpg",
        "https://m.media-amazon.com/images/G/31/img24/asus/f16/mac-1400_2._SX1242_QL85_FMpng_.png"
      ],
      currentIndex: 0, // Tracks the starting index of the visible images
      imagesPerSlide: 4, // Number of images to show at a time
        action: "",
        tab_name: '',
        sub_tabs: [
        {title: 'Damage Position', key: 'position',width: '20%'},
        {title: 'Annotation', key: 'value', width: '40%'},
        {title: 'Images', key: 'image_url', width: '40%'}
        ],
        sub_tabs_journy: [
        {title: 'Disposition Status', key: 'disposition'},
        {title: 'Sub Status', key: 'status'},
        {title: 'Entry Date', key: 'entry_date'},
        {title: 'TAT', key: 'tat_days'},
        {title: 'Comments', key: 'comment'},
        {title: 'Attachments', key: 'attachment_display'},
        {title: 'User', key: 'status_changed_by'},
        ],
        grading_results: [],
        journy_data: [],
        item_details_hash: [],
        searched_item: {},
        imagePopupVisible: false,
        selectedImage: null, 
        showItemFound:false,
        item_status: '',
        item_text: '',
        heading: '',
        output: '',
        images: [],
        checkedImages: [],
        alert_message: '',
        alert_type: 'info',
        imageDailog: false,
        imageDailog2: false,
        item_image_url: '',
        itemAttrEXp: false,
        itemJournExp: false,
        gradingJourExp : false,
        financialJournExp : false,
        warrantyJournExp: false,
        documentRepoExp : false,
        activeImage : null,
        testReport1 : false,
        item_attribute_resp : [],
        item_journey_resp : [],
        financial_journey_resp : [],
        grading_journey_resp : [],
        warranty_history_resp : [],
        document_repository_resp : [],
        slider_disabled : true,
        expand_all : true,
        viewBomPopup : false,
        dialog: false,
        startThumbIndex: 0, 
        imagesList: [],
        forwardHeader : [
          { title: "Date", key: "date"},
          { title: "Transaction Description", key: "transaction"},
          { title: "Credit(₹)", key: "credit"},
          { title: "Debit(₹)", key: "debit"},
          { title: "Balance(₹)", key: "balance"},
        ],
        reverseHeader : [
          { title: "Date", key: "date"},
          { title: "Transaction Description", key: "transaction"},
          { title: "Credit(₹)", key: "credit"},
          { title: "Debit(₹)", key: "debit"},
          { title: "Balance(₹)", key: "balance"},
        ],
        bom_headers : [
          { title : "Child Article ID", key : "child_article_id"},
          { title : "Quantity", key : "quantity"},
        ],
        bom_table_data : [],
        testReportPopup : false,
        forwardTableData : [],
        grading_test_report : '',
        reverseTableData : [],
        image_src_popup : false,
        image_src : '',
        searched_document : '',
        searched_data:'',
        warantyHeader : [
          { title : "Date", key : "date"},
          { title : "Warranty Claim Instance", key : "warrantyDate"},
          { title : "Sales Channel", key : "salesChannel"},
          { title : "Claim Channel", key : "claimChannel"},
          { title : "Defect Type", key : "defectType"},
          { title : "Resolution Decision", key : "resolutionDecision"},
          { title : "Closure Date", key : "closureDate"},
          { title : "Warranty Servicing Cost", key : "warrantyCost"},
        ],
        warantyTableData : [],
        header_text : 'Item Information',
        ird_det_headers : [
          { title : "Tag ID", key : "tag_number"},
          { title : "Artcle ID", key : "article_id"},
          { title : "Article Description", key : "article_description"},
          { title : "Map", key : "map"},
          { title : "Disposition", key : "disposition"},
        ],
        ird_det_items : [
         {
           id : 1,
           tag_number : '12212',
           article_id : '12212',
           article_description : 'Samsund 235 litersss',
           map : 'Bangalore',
           disposition : 'Repair',
         },
         {
           id : 2,
           tag_number : '12213',
           article_id : '12213',
           article_description : 'Samsund 235 litersss',
           map : 'Mumbai',
           disposition : 'Markdown',
         }
        ],
        label_search : 'Search by Tag ID/Serial Number',
        ird_details : [],
        replaceFileDialog:false,
        replace_file: null,
        fileErrorMessage:'',
        fileError: false,
        doc_details : {},
        snackbar: {
            color: null,
            icon: null,
            mode: null,
            position: "top",
            text: null,
            timeout: 7500,
            title: null,
            visible: false,
          },
          role:'',
         page: 1,
         totalPages: 1,
         totalCount: '',
         pageSize: defaultPageSize,
         pageSizes: defaultPageSizes,
         visible_ird_items_count: 10,
         loadingIrdItems: false,
      };
    },
    created() {
      this.role = this.$store.state.currentUser.roles[0]
      if (this.$route.params.type && this.$route.params.type == 'external'){
        this.search = this.$route.params.tag_number
      } else {
        this.search = this.$route.query.search
      }
      
      // Close the mobile drawer if it's open
      if (this.$store.state.isMobile) {
        this.$nextTick(() => {
          window.dispatchEvent(new CustomEvent('close-mobile-drawer'));
        });
      }
      
      this.searched_data = this.$store.state.searched_tagid;
      this.searched_ird = this.$store.state.searched_ird;
      if(this.searched_ird === "tag"){
       this.header_text = 'Item Information' 
       this.label_search = 'Search by Tag ID/Serial Number'
       this.searchItem('searching first time')
      }else{
        this.header_text = 'IRD'
        this.label_search = 'Search by IRD No'
        this.fetchIRDDetails();
      }
    },
    watch:{
        '$store.state.searched_tagid': function(newTab) {
         if(Boolean(this.$store.state.searched_ird && this.$store.state.searched_tagid)){
         if(this.$store.state.searched_ird === "ird"){
             this.searched_ird = this.$store.state.searched_ird
             this.search = newTab
              this.searched_data = newTab
             this.header_text = 'IRD'
             this.label_search = 'Search by IRD No'
             this.fetchIRDDetails();   
         } else {
            console.log('newTab1', newTab)
            this.searched_ird = this.$store.state.searched_ird
            this.header_text = 'Item Information'
            this.label_search = 'Search by Tag ID/Serial Number'
            this.search = newTab
            this.searched_data = newTab
            this.searchItem('using_watcher'); 
         }
        }           
      },
      // '$store.state.searched_ird': function(newTab) {
      //    console.log('newTab2', newTab)         
      //     },
    },
    components: {
      editor: Editor,
      HeaderComponent,
      Loading
    },
    computed: {
      visibleImages() {
        // Use item_attribute_resp['Attachments'] instead of customImages
        return this.item_attribute_resp['Attachments']
          ? this.item_attribute_resp['Attachments'].slice(
              this.currentIndex,
              this.currentIndex + this.imagesPerSlide
            )
          : [];
      },
      },
    methods: {
      onIrdIntersect(isIntersecting) {
        if (isIntersecting && !this.loadingIrdItems && this.page < this.totalPages) {
          this.fetchIRDDetails(true);
        }
      },
      prevSlide() {
        if (this.currentIndex > 0) {
          this.currentIndex -= 1;
        }
      },
      nextSlide() {
        if (
          this.item_attribute_resp['Attachments'] &&
          this.currentIndex + this.imagesPerSlide < this.item_attribute_resp['Attachments'].length
        ) {
          this.currentIndex += 1;
        }
      },
      prevThumbs() {
      if (this.startThumbIndex > 0) {
        this.startThumbIndex--;
      }
    },
    nextThumbs() {
      if (this.startThumbIndex + 4 < this.item_attribute_resp["Attachments"].length) {
        this.startThumbIndex++;
      }
    },openPopup(index) {
      this.currentIndex = index;
      this.dialog = true;
    },
      async generatePDF() {
    // Generate PDF from the HTML content inside the dialog
        const element = document.getElementById('pdf-content');
        await html2pdf(element);
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },

      // loadData(tab) {
      //   this.checkedImages = []
      //   this.active_tab = tab;
      //   if (this.active_tab == 'Item Details') {
      //     this.item_details_hash = this.searched_item.item_details
      //   }else if (this.active_tab == 'Outward Documents'){
      //     this.item_details_hash = this.searched_item.outward_details
      //   } else if (this.active_tab == 'Packing'){
      //     this.grading_results = this.searched_item.packaging_info.Packaging
      //     this.heading = 'Packaging'
      //     this.output = this.searched_item.packaging_info.Output
      //     this.images = this.searched_item.packaging_info.Images
      //     this.sub_tabs = [
      //     {title: 'Damage Position', key: 'position',width: '20%'},
      //     {title: 'Annotation', key: 'value', width: '40%'},
      //     {title: 'Images', key: 'image_url', width: '40%'}
      //     ]
      //   }else if (this.active_tab == 'Item Condition'){
      //     this.grading_results = this.searched_item.item_condition_info.ItemCondition
      //     this.heading = 'Item Condition'
      //     this.output = this.searched_item.item_condition_info.Output
      //     this.images = this.searched_item.item_condition_info.Images
      //     this.sub_tabs = [
      //     {title: 'Damage Position', key: 'position',width: '20%'},
      //     {title: 'Annotation', key: 'value', width: '40%'},
      //     {title: 'Images', key: 'image_url', width: '40%'}
      //     ]
      //   }else if (this.active_tab == 'Functional Condition'){
      //     this.grading_results = this.searched_item.functional_info.Functional
      //     this.sub_tabs= [
      //     {title: 'Functional Question', key: 'position',width: '20%'},
      //     {title: 'Answer', key: 'value', width: '40%'}
      //     ]
      //     this.heading = 'Functional Condition'
      //     this.output = this.searched_item.functional_info.Output
      //   }else if (this.active_tab == 'Accessories'){
      //     this.grading_results = this.searched_item.accessories_info.Accessories
      //     this.sub_tabs= [
      //     {title: 'Accessories Question', key: 'position',width: '20%'},
      //     {title: 'Answer', key: 'value', width: '40%'}
      //     ]
      //     this.heading = 'Accessories'
      //     this.output = this.searched_item.accessories_info.Output
      //   } else if (this.active_tab == 'Item Journey'){
      //     this.journy_data = this.searched_item.item_journey

      //     this.journy_data.sort((a, b) => {
      //       return (new Date(b.created_at)) - (new Date(a.created_at))
      //     });
      //     return items;
      //   }

      // },
       loadData(tab) {
        this.checkedImages = [];
        this.active_tab = tab;
        this.selected_tab = this.tabs.indexOf(tab);
        console.log("Selected Tab:", this.selected_tab);
        console.log("Active Tab:", this.active_tab);
        if (this.active_tab == 'Item Attributes') {
          this.item_details_hash = this.searched_item.item_details;
        } else if (this.active_tab == 'Item Journey') {
          if (this.searched_item.item_journey) {
            this.journy_data = this.searched_item.item_journey;
            this.journy_data.sort((a, b) => {
              return (new Date(b.created_at)) - (new Date(a.created_at));
            });
          } else {
            console.error('Item journey info is undefined');
          }
        } else if (this.active_tab == 'Financial Journey') {
          if (this.searched_item.financial_info) {
            this.financial_journey_resp = this.searched_item.financial_info;
          } else {
            console.error('Financial info is undefined');
          }
        } else if (this.active_tab == 'Grading Journey') {
          if (this.searched_item.grading_info) {
            this.grading_journey_resp = this.searched_item.grading_info;
          } else {
            console.error('Grading info is undefined');
          }
        } else if (this.active_tab == 'Warranty History') {
          if (this.searched_item.warranty_info) {
            this.warranty_history_resp = this.searched_item.warranty_info;
          } else {
            console.error('Warranty info is undefined');
          }
        } else if (this.active_tab == 'Document Repository') {
          if (this.searched_item.document_info) {
            this.document_repository_resp = this.searched_item.document_info;
          } else {
            console.error('Document info is undefined');
          }
        }
      },
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },

      openItemAttribute(){
        this.itemAttrEXp = !this.itemAttrEXp;
        // this.activeImage = this.images[0];
      },
      openItemJourney(){
        this.itemJournExp = !this.itemJournExp;
      },
      openFinancialJourney(){
        this.financialJournExp = !this.financialJournExp;
      },
      openGradingJourney(){
        this.gradingJourExp = !this.gradingJourExp;
      },
      openWarrantyJourney(){
        this.warrantyJournExp = !this.warrantyJournExp;
      },
      openDocumentRepo(){
        this.documentRepoExp = !this.documentRepoExp;
      },
      handleImageClick(image) {
        this.activeImage = image;
      },
      // reverseViewTestReport(){
      //   this.testReport1 = !this.testReport1;
      // },
      viewTestReport(index){
        this.grading_test_report = this.grading_journey_resp[index]
        this.testReportPopup = true;
      },
      openImagePopup(src){
        this.testReportPopup = false;
        this.image_src_popup = true;
        this.image_src = src;
      },
      searchItem(value) {
         if(value != 'searching first time'){
            this.$store.commit('setSearchedItemId', {
               'searched_tagid': this.searched_data,
               'searched_ird': this.searched_ird
            })
         }
        if(value === "search_by_tabnumber"){
          this.search = this.searched_data
          return;
        }
        if (this.search == ''){
         //  this.showAlert("error", "Please provide value in search");
          return
        }
        this.search_text = ''
        if(this.searched_ird === "ird"){
           this.fetchIRDDetails();
        }else{
          this.slider_disabled = false;
         this.getItemAttributeDetail();
         this.getItemJourneyDetail();
         this.getFinancialJourney();
         this.getGradingJourney();
         this.getWarrantyHistory();
         this.getDocumentRepository();
        }
        
      },
      getItemAttributeDetail(){
        this.isLoading =true
        // const params =  {
        //       tag_number: this.search
        //     }
        this.$httpSecured
          .get(`/api/v1/warehouse/inventories/get_item_attributes?tag_number=${this.search}`)
          .then((response) => {
            this.item_attribute_resp = response.data.item_attributes
            this.bom_table_data = this.item_attribute_resp.BOM ? this.item_attribute_resp.BOM : [];
            this.activeImage = null
            if(this.item_attribute_resp.Attachments.length > 0)
              this.activeImage = this.item_attribute_resp.Attachments[0]
            this.$toast.success('Item Found');
          })
          .catch((error) => {
            this.isLoading =false
            this.$toast.error(error.response.data.error);
          });
      },
      getItemJourneyDetail(){
        this.isLoading =true,
        this.$httpSecured
          .get("/api/v1/warehouse/inventories/get_item_journey", {params: {tag_number: this.search}})
          .then((response) => {
            this.isLoading =false
            this.item_journey_resp = response.data.item_journey
          })
          .catch((error) => {
            this.isLoading =false
          });
      },
      getFinancialJourney(){
        this.isLoading =true,
        this.$httpSecured
          .get("/api/v1/warehouse/inventories/get_financial_journey", {params: {tag_number: this.search}})
          .then((response) => {
            this.isLoading =false
            this.financial_journey_resp = response.data
            this.forwardTableData = [];
            this.reverseTableData = []
            let balance = 0
            if(this.financial_journey_resp.forward_supply_chain){
              this.financial_journey_resp.forward_supply_chain.forEach(item =>{
                let temp = { 'date' : '', 'transaction' : '', 'credit'  : '-', 'debit' : '-', 'balance' : ''}
                temp.date = item.date_of_creation,
                temp.transaction = item.transaction_description
                if(item.type_of_amount == 'credit'){
                  temp.credit = item.amount
                  balance = balance + item.amount
                  temp.balance = balance
                }  else {
                  temp.debit = item.amount
                  balance = balance - item.amount
                  temp.balance = balance
                } 
                this.forwardTableData.push(temp)
              })
            }
            if(this.financial_journey_resp.reverse_supply_chain){
              this.financial_journey_resp.reverse_supply_chain.forEach(item =>{
                let temp = { 'date' : '', 'transaction' : '', 'credit'  : '-', 'debit' : '-', 'balance' : ''}
                temp.date = item.date_of_creation,
                temp.transaction = item.transaction_description
                if(item.type_of_amount == 'credit'){
                  temp.credit = item.amount
                  balance = balance + item.amount
                  temp.balance = balance
                }  else {
                  temp.debit = item.amount
                  balance = balance - item.amount
                  temp.balance = balance
                } 
                this.reverseTableData.push(temp)
              })
            }
          })
          .catch((error) => {
            this.isLoading =false
          });
      },
      getGradingJourney(){
        this.isLoading =true,
        this.$httpSecured
          .get("/api/v1/warehouse/inventories/get_grading_journey", {params: {tag_number: this.search}})
          .then((response) => {
            this.isLoading =false
            this.grading_journey_resp = response.data.grading_items ? response.data.grading_items : response.data.return_item_grading_results
          })
          .catch((error) => {
            this.isLoading =false
          });
      },
      getWarrantyHistory(){
        this.isLoading =true,
        this.$httpSecured
          .get("/api/v1/warehouse/inventories/get_warranty_history", {params: {tag_number: this.search}})
          .then((response) => {
            this.isLoading =false
            this.warranty_history_resp = response.data
          })
          .catch((error) => {
            this.isLoading =false
          });
      },
      getDocumentRepository(){
        this.isLoading =true,
        this.$httpSecured
          .get("/api/v1/warehouse/inventories/get_documents_repository", {params: {tag_number: this.search, search_text: this.searched_document}})
          .then((response) => {
            this.isLoading =false
            this.document_repository_resp = response.data.documents_repository
          })
          .catch((error) => {
            this.isLoading =false
          });
      },
      formatCurrency(value) {
        if (value == null || value === '' || isNaN(value)) return '-';
        return parseFloat(value).toLocaleString('en-IN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      },
      // searchItem(){
      //   if (this.search.length == 0){
      //     this.showAlert("error", "Please provide value in search");
      //     return
      //   }
      //   this.isLoading =true,
      //   this.$httpSecured
      //     .get("/api/v1/warehouse/inventories/item_info", {params: {tag_number: this.search}})
      //     .then((response) => {
      //         if (response.data.inventory) {
      //           this.isLoading =false
      //           this.searched_item = response.data.inventory;
      //           this.showItemFound = true
      //           this.item_status = 'green'
      //           this.item_text = 'Item Found'
      //           this.loadData('Item Details')
      //           this.active_tab = 'Item Details'
      //           this.checkedImages = []
      //         }else{
      //           this.isLoading =false
      //           this.showItemFound = true
      //           this.item_status = 'red'
      //           this.item_text = 'Item Not Found'
      //           this.checkedImages = []
      //         }
      //     })
      //     .catch((error) => {
      //       this.isLoading =false
      //       this.$toast.error(error.response.data.error);
      //     });
      //   },

        backToTestReport(){
          this.testReportPopup = true;
          this.image_src_popup = false;
        },
        calculate_date(item){
          const date_format = item.date.slice(0,10)
          const parts = date_format.split('/');
          const year = parts[0] // Take last 2 digits of the year
          const month = parts[1];
          const day = parts[2];
          return `${day}/${month}/${year}`;
        },
        calculate_time(item){
          return item.date.slice(11)
        },
        grading_date(item){
          return item.create_date.slice(0,10).split('/').reverse().join('/');
          
        },
        grading_time(item){
          return item.create_date.slice(11)
        },
        viewBom(){
          this.viewBomPopup = true;
        },
        openImageDialog(item){
          this.images = item.image_url
          this.imageDailog = true
        },
        expand_all_function(){
          if(this.expand_all){
            this.itemAttrEXp = true
            this.itemJournExp = true
            this.financialJournExp = true
            this.gradingJourExp = true;
            this.warrantyJournExp = true;
            this.documentRepoExp = true
          } else {
            this.itemAttrEXp = false
            this.itemJournExp = false
            this.financialJournExp = false
            this.gradingJourExp = false
            this.warrantyJournExp = false
            this.documentRepoExp = false
          }
          this.expand_all = !this.expand_all
        },
        downloadImage(){
          if (this.checkedImages.length <= 0) {
            this.showAlert("error", "Please Select any on image to download");
            return
          }
          for (var i = 0; i <= this.checkedImages.length-1; i++) {
            var fileLink = document.createElement('a');

            fileLink.href = this.checkedImages[i]
            fileLink.setAttribute('target', '_blank');
            document.body.appendChild(fileLink);

            fileLink.click();
          }
        },

        downloadFile(document_url) {
          const url = API_URL+'/api/v1/warehouse/inventories/download_documents?file_path=' + document_url
          const link = document.createElement('a');
            link.href = url; 
            link.target = '_blank';
            link.download = 'download.csv'; 
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        openImage(url){
          var fileLink = document.createElement('a');

          fileLink.href = url
          fileLink.setAttribute('target', '_blank');
          document.body.appendChild(fileLink);
          fileLink.click();
        },

        closeImageDialog(){
          this.imageDailog = false
          this.checkedImages = []
        },
        fetchIRDDetails(isLoadMore = false){
         if (isLoadMore) {
           this.loadingIrdItems = true;
           this.page++;
           if (this.$store.state.isMobile) {
             this.pageSize = 10;
           }
         } else {
           this.isLoading = true;
           this.ird_details = [];
           this.ird_det_items = [];
           if (this.$store.state.isMobile && this.page === 1) {
             this.pageSize = 10;
           }
         }
         
         const params = {
                  ird_number: this.search,
                  page: this.page,
                  per_page: this.pageSize,
               };
         this.$httpSecured
            .get("api/v1/warehouse/inventories/search_by_ird", {params: params})
            .then((response) => {
               if (response.data && response.data.ird_journey) {
                 this.loadingIrdItems = false;
                 this.isLoading = false;
                 if (isLoadMore) {
                   this.ird_det_items = [...this.ird_det_items, ...response.data.ird_details.pending_receipt_document_items];
                 } else {
                   this.ird_details = response.data;
                   this.ird_det_items = response.data.ird_details.pending_receipt_document_items;
                 }
                 this.totalPages = response.data.meta.total_pages;
                 this.totalCount = response.data.meta.total_count;
               } else {
                 this.loadingIrdItems = false;
                 this.isLoading = false;
                 this.showAlert("error", response.data.message);
               }
            })
            .catch((error) => {
               this.loadingIrdItems = false;
               this.isLoading = false;
            });
         },
      getLastStatus(status) {
            if (Array.isArray(status)) {
               return status[status.length - 1];
            }
            return status || 'PRD not created';
         },
      openDialogFile(item) {
         this.replaceFileDialog = true;
         this.replace_file = null;
         this.doc_details = item
      },
      changeFile() {
         if (this.replace_file) {
         const fileType = this.replace_file.type;
         if (fileType !== 'application/pdf' && (fileType !== 'image/png' && fileType !== 'image/jpeg')) {
            this.fileError = true;
            this.fileErrorMessage = 'Only PDF and PNG files are allowed.';
         } else {
            this.fileError = false;
            this.fileErrorMessage = '';
         }
         }
      },
      submitUpdateConfirmation(){
          this.number++;
          let params = {};
         const formData = new FormData();
                  formData.append("document_type_id", this.doc_details.document_type_id);
                  formData.append("document_type", this.doc_details.document_type);
                  formData.append("document_type_field", this.doc_details.document_type_field); 
                  formData.append("file", this.replace_file); 
         params = formData;         
         this.$httpSecured.post("/api/v1/warehouse/inventories/upload_document", params)
          .then(response => {
            if (response.data) {
              this.replaceFileDialog = false;
              this.replace_file = null;
              this.getDocumentRepository();
              this.snackbar = {
              color: "success",
              icon: "mdi-check-circle",
              mode: "multi-line",
              position: "bottom",
              timeout: 2000,
              title: 'Success',
              text: response.data.message,
              visible: true
            }; 
            } else {
              this.number = 0;
              this.$toast.error("No Data Found");
            }
          }).catch(error => {
            this.$toast.error(error.response.data.error)
            this.number = 0;
            this.loading = false;

          }); 
       },
       handlePageSizeChange(size){
        this.pageSize = size;
        this.page = 1
        this.fetchIRDDetails()
      },
      handlePageChange(value) {
        this.page = value;
        this.fetchIRDDetails()
      },
    },
    filters: {
      truncate: function(text, length, suffix) {
        if (text?text.length:0 > length) {
          return text.substring(0, length) + suffix;
        } else {
          return text;
        }
      }
    }
  };
</script>
<style scoped>
  .theme--light.v-icon {
    color: #1867c0!important;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    font-size: 14px !important;
  }
  .v-table > .v-table__wrapper > table >thead{
    background-color: #d6e3ef!important;
  }
  .v-card {
    max-width: 97% !important;
  }

  .v-card-100 {
    max-width: 100% !important;
  }
  .inc-title{
    color: #172B4D;
    font-size: 20px;
  }
  .titleCard{
    margin: 0px 20px 16px 20px;
  }
  .titleCarditem{
   /* margin: 0px 20px 16px 20px; */
    overflow-y: scroll;
    height: calc(var(--vh, 1vh) * 100 - 300px) !important;
  }
  .cardTextHeader{
    font-size: 1.1rem;
    font-weight: 600;
    padding: 10px 16px;
  }
  .v-data-table-header{
    background-color: #D6E3EF !important;
  }
  .gpOfBox{
    background-color: #F4F8FA;
    border-radius: 12px;
    margin-bottom: 32px
  }
  .spaceBetween{
    display: flex;
    justify-content: space-between;
  }
  .verticalDashedDivider{
    position: relative;
    left: -13px;
    top: 46%;
    border: 2px dashed;
  }
  .iconStyle{
    background-color: #EDEDF8;
    padding: 12px;
    height: 40px !important;
    width: 40px !important;
    border-radius: 4px;
  }
  .green_col{
    color : green;
  }
  .red_col{
    color : red;
  }
  .test_report_header{
    background-color: #003C9E;
    color:white;
  }
  .underline_css{
    width:94px;
    height:2px;
    background: #1A1B35;
  }
  .custom-tabs {
    background-color: #f8fafd; /* Light blue-gray background */
    border-radius: 10px;
    padding: 5px;
  }

  .custom-tab {
    text-transform: none !important;
    text-decoration: none;
    color: #4a4a4a; /* Default text color */
    background-color: #f0f5ff; /* Light blue */
    border-radius: 8px !important;
    padding: 8px 16px;
    margin: 0 5px;
    min-width: 150px;
    height: 40px !important;
    transition: background-color 0.3s ease-in-out;
  }

  .custom-tab:hover {
    background-color: #dbe6ff; /* Slightly darker blue on hover */
  }

  /* Active tab styling */
  .v-tab.v-tab--active {
    background-color: #0057d9 !important; /* Active tab background */
    color: white !important;
    font-weight: bold;
  }
  ::v-deep(.custom-tab.v-tab--selected) {
    background-color: #0057d9 !important; /* Active tab background color */
    color: white !important; /* Active tab text color */
    font-weight: bold; /* Optional: Make the text bold */
  }

  ::v-deep(.custom-tab.v-tab-item--selected) {
    background-color: #0057d9 !important; /* Active tab background color */
    color: white !important; /* Active tab text color */
    font-weight: bold; /* Optional: Make the text bold */
  }
  .image-card {
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Shadow effect */
    border-radius: 16px; /* Rounded corners */
    padding: 30px; /* Inner padding */
    border: 1px solid rgba(0, 0, 0, 0.1); /* Line border with opacity */
    height: 230px;
  }
  .image-fit {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain; /* Ensures the whole image fits */
      padding:10px;
      border-radius:15px;
    }
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .nav-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.2);
  }

  .left-btn {
    left: 10px;
  }

  .right-btn {
    right: 10px;
  }

  .thumbnail-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

  .thumbnail-wrapper {
    display: flex;
    overflow-x: auto;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    gap: 10px;
  }

  .thumbnail {
    width: 80px;
    height: 60px;
    cursor: pointer;
    padding: 20px;
    margin: 15px;
    border: 2px solid transparent;
  }

  .thumbnail.active {

  }
  .thumb-nav-btn {
    background-color: rgba(0, 0, 0, 0.2);
  }
  .custom-card {
    box-shadow: 
    -4px 0px 6px rgba(0, 0, 0, 0.1), /* Left shadow */
     4px 0px 6px rgba(0, 0, 0, 0.1),  /* Right shadow */
     0px 4px 6px rgba(0, 0, 0, 0.2) !important; /* Bottom shadow */
  }
  .bold-size{
   font-size: 18px;
   font-weight: 600;
  }
  .error-color{
    color: #EC0101;
  }
  .label {
    font-size: 12px;
    color: #666;
    font-weight: 400;
    margin-bottom: 2px;
  }
  .value {
    font-size: 14px;
    color: #000;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .expansion-icon {
    transition: transform 0.3s ease;
  }
  .v-expansion-panel--active .expansion-icon {
    transform: rotate(180deg);
  }
  /* Hide default expansion panel icon */
  .v-expansion-panel-title__icon {
    display: none !important;
  }
 
:deep(.v-data-table thead th) {
  background-color: #D6E3EF !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}
.customer-details {
    background-color: #EAF4FF !important;
  }
  .customer-details label {
    color: #002F9E;
    font-weight: 600;
    font-size: 18px;
  }
  .detail-heading {
    font-weight: 600;
    color: #2D2D2D;
    font-size: 14px;
  }
  .dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 200px) !important;
  }
  
  @media (max-width: 600px) {
    .titleCard {
      margin: 0px 0px 16px 0px !important;
    }
    .titleCarditem {
      margin: 0px 0px 16px 0px !important;
      padding: 0px !important;
      height: calc(var(--vh, 1vh) * 100 - 265px) !important;
    }
    .custom-card {
      border-radius: 0px !important;
      box-shadow: none !important;
    }
    .v-card-title {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
    /* Override internal margins for new mobile elements */
    .mx-2 {
      margin-left: 0px !important;
      margin-right: 0px !important;
    }
    .mx-4 {
      margin-left: 0px !important;
      margin-right: 0px !important;
    }
     .customer-details {
      padding: 16px 20px !important;
      margin: 8px 0 !important;
      border-radius: 8px !important;
    }
    .customer-details label {
      font-size: 14px;
      line-height: 1.4;
      letter-spacing: 0.2px;
      font-weight: 600;
    }
    .dynamic-height-dis-card {
      
      margin-left: 10px;
      /* padding-right: 10px; */
    }
    .no-indent :deep(.v-expansion-panel-text__wrapper) {
      padding: 0 !important;
    }
  }

  .v-expansion-panel-title:focus {
    outline: none !important;
    border: none !important;
  }
  :deep(.v-expansion-panel-title__overlay) {
    background-color: transparent !important;
  }
  .no-padding-row {
    padding-right: 0 !important;
  }
</style>